import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { YoutubeOutlined, CloseOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";


const SubscribePopup = () => {

  const location = useLocation();

  var YOUTUBE_CHANNEL_URL = location == '/vedikshha' ?  "https://www.youtube.com/@Vedikshha09?sub_confirmation=1" :  "https://www.youtube.com/@KFETalkShow?sub_confirmation=1";


  var YOUTUBE_VIDEO_ID =location == '/vedikshha' ? "s5lCWR1KqHo" : "nipeQpoqszg";

  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Show popup 30 seconds after first visit
    const firstTimeout = setTimeout(() => {
      setOpen(true);

      // Then show popup every 5 minutes (300000 ms)
      const interval = setInterval(() => {
        setOpen(true);
      }, 300000);

      // Cleanup interval when component unmounts
      return () => clearInterval(interval);
    }, 30000); // 30 seconds

    // Cleanup first timeout
    return () => clearTimeout(firstTimeout);
  }, []);

  const handleSubscribe = () => {
    window.open(YOUTUBE_CHANNEL_URL, "_blank");
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      footer={null}
      centered
      closable={false}
      width={460}
      zIndex={9999}
    >
      <div className="bg-white p-2" style={{ position: "relative" }}>
        <button
          className="bg-red-50  hover:bg-red-500 text-black hover:text-white"
          onClick={() => setOpen(false)}
          style={{
            position: "absolute",
            top: -10,
            right: -10,
            background: "#fff",
            borderRadius: "50%",
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
        >
          <CloseOutlined />
        </button>

        {/* YouTube Video */}
        <div style={{ borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
          <iframe
            width="100%"
            height="240"
            src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&mute=1&rel=0`}
            title="YouTube video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>

        {/* Text */}
        <h2 style={{ textAlign: "center", fontWeight: 700, marginBottom: 8 }}>
          Subscribe Our YouTube Channel
        </h2>

        <p style={{ textAlign: "center", color: "#6b7280", marginBottom: 20 }}>
          Get latest videos, updates & exclusive content.
        </p>

        {/* Subscribe Button */}
        <Button
          type="primary"
          size="large"
          icon={<YoutubeOutlined />}
          block
          onClick={handleSubscribe}
          style={{
            background: "#ff0000",
            borderColor: "#ff0000",
            fontWeight: 600,
          }}
        >
          Subscribe on YouTube
        </Button>
      </div>
    </Modal>
  );
};

export default SubscribePopup;